import { useSelector } from 'react-redux';
import { useStatesWithFeeIncluded } from 'pages/search/hooks/total-price-toggle/use-states-with-fee-included';
import { getSearchCountryCode, getSearchState } from 'store/selectors/selectors';
export const useIsTotalPriceEnabledForStateCountry = () => {
    const searchState = useSelector(getSearchState);
    const searchCountry = useSelector(getSearchCountryCode);
    const statesWithFeeIncluded = useStatesWithFeeIncluded();
    if (statesWithFeeIncluded) {
        const matchCountry = statesWithFeeIncluded.find(s => s.name === searchCountry);
        const shouldShowTotal = matchCountry &&
            (!matchCountry.states || matchCountry.states.includes(searchState));
        return shouldShowTotal ?? false;
    }
    return false;
};
